import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-dialog-confirm-stats-recalculation',
  templateUrl: './dialog-confirm-stats-recalculation.component.html',
  styleUrls: ['./dialog-confirm-stats-recalculation.component.scss'],
})
export class DialogConfirmStatsRecalculationComponent {
  @Input() value: any;
}
